import React from 'react';
import { MainDetail } from '../mainDetail/MainDetail';
import OtherProjectDetail from '../otherProjectDetail/OtherProjectDetail';
import { TransformedProjectNetDataType } from '../../../common/helpers/data/transformProjectnetProjectData';

interface ProjectDetailProps {
  window?: Window;
  projectData: unknown;
}
const ProjectDetail: React.FC<ProjectDetailProps> = ({
  window,
  projectData,
}) => {
  return (
    <div data-test={'project-detail'}>
      <MainDetail window={window} projectData={projectData} />
      <OtherProjectDetail
        window={window}
        projectData={projectData as TransformedProjectNetDataType}
      />
    </div>
  );
};

export default ProjectDetail;
